export type ClassNamesArg = unknown | Record<string, unknown>;

export default function classNames(...args: ClassNamesArg[]) {
    const result = [];
    for (const arg of args) {
        if (typeof arg === 'string' && arg.trim()) {
            result.push(arg.trim());
        } else if (Object.prototype.toString.call(arg) === '[object Object]') {
            for (const [className, condition] of Object.entries(
                arg as Record<string, unknown>
            )) {
                if (condition && className.trim()) {
                    result.push(className.trim());
                }
            }
        }
    }

    if (!result.length) return;

    return result
        .reduce((p, c) => {
            if (!p.includes(c)) {
                p.push(c);
            }
            return p;
        }, [] as string[])
        .join(' ');
}
